<template>
    <FormSelect
        class="dob-select dob-month"
        :value="value"
        :dont-localize="true"
        :place-holder="$t('self-service.verify-ownership.month')"
        :options="monthsList"
        :filterable="true"
        :has-error="hasError && !monthsList.find((x) => x.value === value)"
        :label-text="''"
        :disabled="disabled"
        @change="(v) => $emit('input', v)"
    />
</template>

<script>
import { FormSelect } from '@arena/toolkit';
export default {
    name: 'MonthSelectOfDOB',
    components: {
        FormSelect,
    },
    props: {
        value: {
            type: Number,
            default: null,
        },
        hasError: {
            type: Boolean,
            default: false,
            note: 'Checking error state',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        // The regular 12 months
        return {
            monthsList: [...Array(12).keys()].map((index) => ({
                label: `${index + 1}`, //`${index + 1}`.padStart(2, '0'),
                value: index + 1,
            })),
        };
    },
};
</script>

<style></style>
